<script lang="ts">
	import { onMount } from "svelte";
	import Button from "./Button.svelte";
	import ProductInquiryModal from "./ProductInquiryModal.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { formatPhoneNumber } from "../../../core/utils/formatPhoneNumber.js";
	import { servicePhoneNumber } from "../../../core/schema/servicePhoneNumber.js";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import translations from "./HotlineGetInTouch.translations.json";

	onMount(() => {
		const scrollToCenter = (): void => {
			if (window.location.hash === "#hotline") {
				document.getElementById("hotline")?.scrollIntoView({ behavior: "smooth", block: "center" });
			}
		};

		scrollToCenter();
		window.addEventListener("hashchange", scrollToCenter);
		return (): void => {
			window.removeEventListener("hashchange", scrollToCenter);
		};
	});

	const translate = getTranslate(translations);

	export let variant: "default" | "bordered" = "default";

	let showInquiryModal = false;

	$: bordered = variant === "bordered";
	$: headingClass = bordered ? "text-center md:text-left" : "";
</script>

<section id="hotline" class="!my-0">
	<div class="bg-ltprimary-400 {bordered ? 'py-12 xl:py-24' : 'py-24'}">
		<div class="border-lttertiary border-y">
			<div
				class="mx-auto flex max-w-[120rem] flex-col md:flex-row {bordered
					? 'px-8 lg:px-20 xl:px-32'
					: 'px-4 md:px-9 lg:px-16 xl:px-32'}"
			>
				<div class="border-lttertiary flex-1 border-x p-8 text-white {bordered ? 'border-b md:border-b-0' : ''}">
					<h2 class="text-lttertiary mb-4 uppercase tracking-[0.02em] {headingClass}">
						{translate("hotline")}
					</h2>
					<p class="!text-2md mb-10 leading-normal">{nbspify(translate("hotlineDesc"))}</p>
					<p
						class="font-lexend font-normal tracking-normal {bordered
							? '!text-md/normal lg:!text-2lg/normal'
							: '!text-2lg/normal'}"
					>
						<a href="tel:{servicePhoneNumber}">
							{nbspify(formatPhoneNumber(servicePhoneNumber))}
						</a>
					</p>
				</div>
				<div class="border-lttertiary flex-1 border-l border-r p-8 text-white md:border-l-0">
					<h2 class="text-lttertiary mb-4 uppercase tracking-[0.02em] {headingClass}">
						{translate("getInTouch")}
					</h2>
					<p class="!text-2md mb-10 leading-normal">{translate("getInTouchDesc")}</p>
					<Button
						variant="primary"
						icon={arrowRight}
						on:click={() => {
							showInquiryModal = true;
						}}
					>
						{translate("getInTouchAction")}
					</Button>
				</div>
			</div>
		</div>
	</div>
</section>

<ProductInquiryModal bind:show={showInquiryModal} />
